import React from "react";
import { withRouter } from "react-router-dom";
import Cookies from "js-cookie";

import logger from "js/core/logger";
import { withFirebaseAuth } from "js/react/views/Auth/FirebaseAuthContext";
import { LoadingPage } from "js/react/components/LoadingPage";
import sanitizeRelativeUrl from "common/utils/sanitizeRelativeUrl";
import { trackActivity } from "js/core/utilities/utilities";

const log = logger.info(logger.AUTH).bind(logger);

export class Logout extends React.Component {
    constructor(props) {
        super(props);

        let continueUrl = new URL(window.location).searchParams.get("continue") ?? "/";
        continueUrl = sanitizeRelativeUrl(continueUrl);

        this.state = { continueUrl };
    }

    async componentDidMount() {
        const { auth } = this.props;
        const { continueUrl } = this.state;

        // sign out of firebase
        if (auth.currentUser) {
            log("will sign out of firebase");
            await auth.signOut();
            log("did sign out of firebase");
        }

        // wait until <FirebaseAuthProvider> does its thing
        auth.onAuthStateChanged(user => {
            Cookies.set("logged-in", false);
            window.location = continueUrl;
        });
    }

    render() {
        return (
            <LoadingPage />
        );
    }
}

export default withFirebaseAuth(withRouter(Logout));
